/* eslint-disable import/no-anonymous-default-export */
export default {
	bright: {
		'--text-color': 'rgba(114, 119, 124, 1)',
		'--text-color-shade': 'rgba(74, 80, 87, 1)',
		'--text-color-accent': '#11B8DD',
		'--green': 'linear-gradient(180deg, #00E7E0 0%, #1AA39E 100%)',
		'--border-color': '#72777c',
		'--yellow': '#f2c94c',
		'--header-color': 'white',
		'--header-shadow': '0px 2px 3px rgba(0, 0, 0, 0.08)',
		'--background-grad-1': '#f1f1f1',
		'--background-grad-2': '#d9d9d9',
		'--input-background': 'white',
		'--red': '#eb5757',
		'--back-color': 'rgba(74, 80, 87, 0.54)',
		'--bright': '1',
		'--dark': '0',
		'--main-color-shade': '#f8f8f8',
		'--feedback-background': 'linear-gradient(180deg, #00E7E0 0%, #1AA39E 100%)',
		'--feedback-color': '#ffffff',
		'--error-opacity': '1'
	},
	dark: {
		'--text-color': 'white',
		'--text-color-shade': '#393939',
		'--text-color-accent': '#00E7E0',
		'--green': 'linear-gradient(180deg, #00E7E0 0%, #1AA39E 100%)',
		'--border-color': 'white',
		'--yellow': '#f2c94c',
		'--header-color': 'linear-gradient(180deg, #00D6DB 0%, #0C7BC1 100%)',
		'--header-shadow': '0px 3px 4px rgba(0, 0, 0, 0.25)',
		'--background-grad-1': '#313F54',
		'--background-grad-2': '#141B25',
		'--input-background': 'transparent',
		'--red': '#eb5757',
		'--back-color': 'rgba(255, 255, 255, 0.54)',
		'--bright': '0',
		'--dark': '1',
		'--main-color-shade': '#3B4859',
		'--feedback-background': 'linear-gradient(180deg, #00E7E0 0%, #1AA39E 100%)',
		'--feedback-color': '#ffffff',
		'--error-opacity': '1'
	}
};
